module.exports = __webpack_public_path__ + "static/media/image-nutrition-ftu.5f8d5217.svg";